export default __webpack_public_path__ + "static/media/arrowRigth.320c9cd0.svg";